import styled from 'styled-components';
import Masony from 'react-masonry-component';

export const Container = styled(Masony)`
  ${({ resized }) => `
    width: ${resized ? 'calc(100% - 630px)' : 'calc(100% - 120px)'};
    overflow-y: ${resized ? 'hidden' : 'inherit'};
  `}   
  margin: 20px 60px;
  display: flex;
  justify-content: center;
`;
